export const slideTimeOut = 15000;

export const styles = {
  pageLayout: {
    maxWidth: "85rem",
    mx: "auto",
    // width: "100%",
    px: { xs: 0, sm: 8 },
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sectionSpacing: { mx: "auto", my: { xs: 5, sm: 10 } },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // fontSize: 28,
    fontFamily: "Broadway, Arial, sans-serif",
    letterSpacing: "1px",
    fontSize: 32,
    fontWeight: 500,
    lineHeight: 1,
    // gap: { xs: 0, sm: 0 },
    "& img": {
      objectFit: "contain",
    },
    cursor: "pointer",
    color: "#000dc1",
  },
  readmoreTxtCont: {
    // padding: "2.5px 5px",
    py: 0.5,
    px: 1.5,
    mt: 1,
    cursor: "pointer",
    color: "var(--primary-color)",
    border: "2px solid var(--primary-color)",
    backgroundColor: "#fff",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "25px",
    textTransform: "none",
    transition: "all 0.2s ease-in",
    "&:hover": {
      backgroundColor: "var(--primary-color)",
      color: "#fff",
      transition: "all 0.2s ease-in",
    },
    "&:hover svg": {
      color: "#fff",
    },
    "& svg": {
      color: "var(--primary-color)",
      fontSize: 20,
      transition: "all 0.2s ease-in",
    },
  },
  logoCont: { width: { xs: 30, sm: 30 }, height: { xs: 50, sm: 50 }, pr: 1 },
  subPageHeader: {
    position: "absolute",
    left: -100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: "var(--primary-color)",
    color: "#fff",
    width: "50%",
    height: "100%",
    transform: "skew(20deg)",
    overflow: "hidden",
  },
  headerCont: { position: "fixed", top: 0, left: 0, width: "100%", zIndex: 9, transform: "translateZ(0)", WebkitTransform: "translateZ(0)" },
  menuItem: {
    padding: "1rem",
    fontSize: 14,
    fontWeight: 500,
    color: "#000000",
    transition: "all 0.3s ease-in",
    cursor: "pointer",
    whiteSpace: "nowrap",
    // on hover menu color change
    // "&:hover": {
    //   "& .navlink": {
    //     color: "var(--primary-color)",
    //   },
    //   "& svg": {
    //     color: "var(--primary-color)",
    //   },
    // },
    "& .navlink": {
      // padding: "5px 0",
      // textDecoration: "none",
    },
    "& .hasSubmenu": {
      position: "relative",
      "& .navlink": {
        color: "#000000",
      },
    },
    "&:hover .submenuCont": {
      opacity: 1,
      visibility: "visible",
      top: "100%",
      transition: "all 0.2s ease-in",
    },
    "&:hover svg": {
      color: "var(--primary-color)",
      transform: "rotate(180deg)",
      transition: "all 0.2s ease-in",
    },
  },
  menuArrowIcon: {
    position: "relative",
    left: "0",
    top: "1px",
    fontSize: 35,
    color: "#000000",
    opacity: 0.8,
    transition: "transform 0.2s ease-in",
  },
  subMenuCont: {
    zIndex: 9999,
    position: "absolute",
    top: "150%",
    backgroundColor: "#ffffff",
    opacity: 0,
    visibility: "hidden",
    transition: "all 0.2s ease-in",
    minWidth: "12em",
    padding: "10px 15px",
    // backgroundColor: "#ececec",
    borderRadius: "5px",
    boxShadow: "#65656533 0px 8px 24px",
    borderBottom: "5px solid var(--primary-color)",
    width: "max-content",
  },
  subMenuItem: {
    p: 0,
    transition: "all 0.1s ease-in",
    color: "#000000",
    "& a": {
      padding: "16px 10px",
      fontSize: 14,
    },
    "&:hover": {
      // paddingLeft: "15px",
      transform: "translate(10px)",
      color: "var(--primary-color)",
      transition: "all 0.1s ease-in",
    },
  },
  sideMenuLogo: {
    width: { xs: 25, sm: 45 },
    height: { xs: 50, sm: 60 },
    pr: 1,
  },
  sideMenuCloseIcon: {
    position: "relative",
    top: "3px",
    fontSize: 25,
    color: "var(--primary-color)",
    transform: "rotate(90deg)",
  },
  sideMenuInnerCont: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 30,
    fontWeight: 500,
    lineHeight: 1,
    py: 1,
    px: 2,
    gap: { xs: 0.5, sm: 0 },
    "& img": {
      objectFit: "contain",
    },
  },
  sideBarMenuItem: {
    width: "auto",
    py: 1.5,
    fontSize: 16.5,
    fontWeight: 500,
    pr: 0,
    color: "#000000",
  },
  menuSideBar: {
    "& .MuiPaper-root": {
      height: "80%",
      borderBottom: "15px solid var(--primary-color)",
    },
  },
  twoLineEllipse: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  titleCardCont: {
    position: "relative",
    maxWidth: "85rem",
    mx: "auto",
    // px: { xs: 2.5, sm: 5 },
  },
  titleCardInnerCont: {
    position: "absolute",
    top: { xs: "55%", sm: "65%" },
    left: { xs: 0, sm: "auto" },
    width: { xs: "fit-content", sm: "35%" },
    textAlign: "left",
    backgroundColor: "#ffffff",
    padding: 4,
    margin: { xs: 4, sm: 0 },
    borderRadius: "4px",
    borderBottom: "4px solid var(--primary-color)",
    // borderLeft: "4px solid var(--primary-color)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    // height: "calc(100% - 30%)",
  },
  titleCardHeading: {
    fontWeight: 400,
    fontSize: { xs: 28, sm: 30 },
    mb: 1.5,
  },
  titleCardTextCont: {
    textAlign: "justify",
    // fontSize: { md: "16px", xl: "18px" },
  },
  galImageCont: {
    borderRadius: "20px",
    "& img": {
      width: "100%",
      height: "100%",
      borderRadius: "20px",
      objectFit: "cover",
    },
  },
  serviceItem: {
    maxWidth: "20em",
    p: 3,
    alignSelf: "stretch",
    color: "var(--primary-color)",
    // backgroundColor: "#fafafa",
    border: "2px solid #000",
    borderRadius: "10px",
    boxShadow:
      "rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px",
  },
  bannerBg: {
    height: { xs: "80vh", sm: "85vh" },
    position: "relative",
  },
  sliderStyles: {
    "& .swiper-wrapper": {
      // maxWidth: "85em",
      // margin: "auto",
    },

    ".swiper-pagination": {
      // background: "#fff",
      display: "flex",
      padding: "10px",
      justifyContent: { xs: "center", sm: "space-between" },
      maxWidth: "85rem",
      width: "auto",
      margin: "auto",
      position: "relative !important",
      top: { xs: "0px", sm: "-90px" },
      right: "10px",
      px: { xs: 1.4, sm: 8 },
    },
    ".swiper-pagination-bullet": {
      width: "auto",
      height: "auto",
      fontSize: "1.4em",
      fontWeight: 600,
      borderRadius: 0,
      display: { xs: "none", sm: "block" },
      background: "transparent",
      color: "#fff",
      ":hover": {
        opacity: 1,
      },
    },
  },
  sliderPagination: {
    fontSize: 12,
    ".swiper-pagination-bullet.swiper-pagination-bullet-active": {
      display: "block",
    },
    ".swiper-pagination-bullet-active .pagination-text": {
      position: "relative",
      "::before": {
        content: '""',
        width: "0%",
        top: "-25%",
        left: 0,
        borderTop: "5px solid var(--primary-color)",
        position: "absolute",
        animation: `growWidth ${
          slideTimeOut + 500
        }ms cubic-bezier(0.4, 0, 0.2, 1) infinite`,
      },
      "@keyframes growWidth": {
        "0%": {
          width: "0%",
        },
        "100%": {
          width: "100%",
        },
      },
    },
    "@media (max-width: 599px)": {
      ".swiper-pagination-bullet-active .pagination-text": {
        "::before": {
          borderTop: "4px solid rgba(255,255,255,0.9)",
        },
      },
    },
  },
  chooseusCard: {
    card: {
      alignSelf: "stretch",
      // backgroundColor: "#f9f9f9",
      flex: 1,
      // boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      padding: 2,
      borderRadius: "15px",
      cursor: "pointer",
      transition: "box-shadow 0.3s",
      boxShadow: { xs: "none", sm: "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px" },
      // boxShadow: "var(--primary-color) 0px 25px 20px -30px",
      border: "1px solid #ddd",
      "& .icon": {
        textAlign: "left",
      },
      "&:hover": {
        "& h4": {
          // color: "var(--primary-color)",
          transition: "all 0.3s",
        },
        boxShadow:
          "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
        "& svg": {
          color: "var(--primary-color)",
          transition: "all 0.1s",
          transform: "scale(1.1)",
        },
      },
    },
    title: {
      margin: "8px 0 4px 0",
      transition: "color 0.3s",
      color: "var(--primary-color)",

      textAlign: "left",
    },
    imgCont: {
      "& svg": {
        fontSize: 30,
        width: "33px",
        height: "33px",
        color: "var(--primary-color)",
        transition: "all 0.1s",
      },
    },
    content: { textAlign: "justify" },
  },
  comp4Styles: {
    card: {
      alignSelf: "stretch",
      // backgroundColor: "#f9f9f9",
      flex: 1,
      // boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      padding: 2,
      borderRadius: "15px",
      cursor: "pointer",
      transition: "box-shadow 0.3s",
      boxShadow:
        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",

      "& .icon": {
        textAlign: { xs: "center", sm: "left" },
      },
      "&:hover": {},
    },
    title: {
      margin: "8px 0 4px 0",
      transition: "color 0.3s",
      textAlign: { xs: "center", sm: "left" },
    },
    imgCont: {
      "& svg": {
        fontSize: 30,
        color: "#686868",
        transition: "color 0.3s",
      },
    },
    content: { lineHeight: 1.5, textAlign: "justify" },
  },

  bannerBtn: {
    backgroundColor: "var(--primary-color)",
    color: "#fff",
    borderRadius: "25px",
    py: 0.7,
    px: 2,
    mt: 1,
    fontSize: 12,
    fontWeight: 500,
    ":hover": {
      backgroundColor: "var(--primary-color-2)",
      color: "#ffffff",
      fontWeight: 500,
    },
  },
  hoverTopLine: {
    display: { xs: "block", sm: "inline-block" },
    "::before": {
      content: '""',
      display: "block",
      width: "0%",
      borderTop: "7px solid var(--primary-color)",
      transition: "width 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    ":hover::before": {
      width: { xs: "0%", sm: "100%" },
      transition: "width 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    },
  },
  hoverBottomLine: {
    display: { xs: "block", sm: "inline-block" },
    "::after": {
      content: '""',
      display: "block",
      width: "0%",
      borderTop: "2px solid var(--primary-color)",
      transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    ":hover::after": {
      width: { xs: "0%", sm: "100%" },
      transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    },
  },
  linkText: {
    my: 1,
    fontWeight: 600,
    "& a": {
      cursor: "pointer",
      fontWeight: 500,
      textDecoration: "underline",
      ":hover": {
        color: "darkblue",
      },
    },
  },
  subHeadingText: {
    fontSize: "20px",
    fontWeight: 500,
    opacity: 0.9,
    marginBottom: 0.5,
  },
  footerCont: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: "center",
    justifyContent: "space-between",
    gap: { xs: 1.5, sm: 4 },
    py: { xs: 4, sm: 5 },
    maxWidth: { sm: "70em", md: "85em" },
    mx: 0,
  },
  footerLogoCol: {
    alignSelf: { xs: "center", sm: "flex-start" },
    // fontSize: 40,
    fontFamily: "Broadway, Arial, sans-serif",
    fontSize: 32,
    letterSpacing: "1px",
    fontWeight: 500,
    lineHeight: 1,
    gap: { xs: 0.5, sm: 0 },
    mx: 1,
    color: "#1f2937",
    "& img": {
      objectFit: "contain",
    },
  },
  footerlogotextCont: {
    color: "#4b5563",
    mx: 2,
    my: 2,
    textAlign: { xs: "center", sm: "left" },
  },
  footerQLink: {
    "&:hover": {
      textDecoration: "underline",
      textDecorationColor: "#5b7cfa",
      textUnderlineOffset: "4px",
      background: "linear-gradient(90deg, #5b7cfa, #764ba2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
  },
  hoverIcon: {
    color: "#5b7cfa",
    ":hover": {
      color: "#764ba2",
    },
  },
  copyrightText: {
    textAlign: "center",
    color: "#4b5563",
    background: "linear-gradient(135deg, rgba(91,124,250,0.1) 0%, rgba(118,75,162,0.1) 100%)",
    py: 0.5,
    fontSize: 13,
  },
  textField: {
    fontSize: 14,
  },
  jobPostingCardCont: {
    background: "#f3f3f330",
    borderRadius: 4,
    border: "1px solid #dddddd59",
    padding: 2,
    // minWidth: 220,
    mx: "auto",
    width: { xs: 300, sm: 350 },
    cursor: "pointer",
    transition: "all 0.2s ease-in",
    "&:hover": {
      transition: "all 0.2s ease-in",
      transform: "scale(1.015)",
    },
  },
  cardContainer: {
    // backgroundColor: "#f4f4f42b",
    borderRadius: "8px",
    boxShadow: "4px 3px 13px 3px rgba(0, 0, 0, 0.1)",
    border: "1px solid transparent",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "20px",
    width: "350px",
    transitions: "all 0.3s ease-in",
    "&:hover": {
      borderColor: "#ccc",
      boxShadow: "none",
      transitions: "all 0.3s ease-in",
    },
    "&:hover .imgbox": {
      transform: "scale(1.25)",
      transitions: "all 0.3s ease-in",
    },
  },
  card_top_box: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 1.5,
  },
  icon: {
    // backgrouColor: "var(--bg-color-light-1)",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "50px",
    height: "50px",
    // marginRight: "20px",
    "& img": {
      width: "calc(100% - 12px)",
      height: "calc(100% - 12px)",
    },
  },
};
